import { Component, DoCheck, IterableDiffers, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { SmmPostService } from '../../../_services/smm-post.service';
import { SmmUserService } from '../../../_services/smm-user.service';
import { GlobalService } from '../../../_services/global.service';
import { IProvinceMap } from 'app/_custom/vietnam-map/vietnam-map.component';
import * as html2pdf from 'html2pdf.js';
const moment = require('moment');


@Component({
  selector: 'app-dashboard1',
  templateUrl: './dashboard1.component.html',
  styleUrls: ['./dashboard1.component.scss']
})
export class Dashboard1Component implements OnInit {
  provinceFilter = true;
  projectFilter = true;// Item filter chủ đề
  sourceByTopicFilter = true;

  public msgError = 'LỖI! KHÔNG THỂ KẾT NỐI TỚI MÁY CHỦ';

  // public isLoadData = true;
  // Modal
  modalRef: BsModalRef;

  // Tìm kiếm  
  //@ViewChild(DashboardFilterComponent) dashboardFilterComponent: DashboardFilterComponent;

  public dateInput = { start: moment().subtract(1, 'day'), end: moment() };
  public displayDateInput = 0;
  public bgColor = "transparent";

  // Chart Sắc thái thảo luận
  public semiPieChartTitle = "SẮC THÁI THẢO LUẬN";
  public semiPieChartDetailTitle = "%";
  public semiPieChartDescription = "";
  public semiPieChartSubTitle = "";
  public semiTypeCounts: Array<number>;
  public semiTypeNames: Array<any>;
  public semiProjectId: Array<any>;
  public dataEmptyDS = false;
  public chartWidthDS = 350;// Độ rộng của chart
  public marginTopDS = 0;// Vị trí của chart so với top

  // Chart Nguồn thảo luận
  public pieChartTitle = "NGUỒN THẢO LUẬN";
  public pieChartDetailTitle = "bài viết";
  public typeCounts: Array<number>;
  public typeNames: Array<any>;
  public dataEmpty = false;
  public chartWidth = 380;// Độ rộng của chart
  public marginTop = 50;// Vị trí của chart so với top
  public chartName = "nguon_thao_luan";// Tên chart
  public verticalAlign = "top";
  public maxHeight = 0;

  // Chart Diễn biến thảo luận (Line-chart)
  public lineChartTitle = "DIỄN BIẾN THẢO LUẬN";
  public typesMapArray: Array<Map<any, any>>;
  public typeNamesDE: Array<any>;
  public dataDE: any;
  public dataEmptyDE = false;
  public lineProjectId: Array<any>;

  // Chart Chân dung tác giả (Author Portrait)
  public pieChartTitleAP = "CHÂN DUNG TÁC GIẢ";
  public pieChartDetailTitleAP = "người";
  public typeCountsAP: Array<number>;
  public typeNamesAP: Array<any>;
  public dataEmptyAP = false;
  public chartWidthAP = 350;// Độ rộng của chart
  public marginTopAP = 50;// Vị trí của chart so với top
  public chartNameAP = "chan_dung_tac_gia";// Tên chart
  public verticalAlignAP = "top";
  public maxHeightAP = 0;

  // Chart Chủ đề thảo luận (SJ: subject)
  public pieChartTitleSJ = "CHỦ ĐỀ THẢO LUẬN";
  public pieChartDetailTitleSJ = "%";
  public typeCountsSJ: Array<number>;
  public typeNamesSJ: Array<any>;
  public dataEmptySJ = false;
  public chartWidthSJ = 320;// Độ rộng của chart
  public marginTopSJ = -50;// Vị trí của chart so với top
  public legendYSJ = 20;// Vị trí của legend trục Y
  public chartNameSJ = "chu_de_thao_luan";// Tên chart
  public verticalAlignSJ = "bottom";
  public maxHeightSJ = 75;

  //Vietnam map
  public mapChartTitle = "VỊ TRÍ THẢO LUẬN";
  public dataProvince: IProvinceMap[];

  constructor(
    private smmPostService: SmmPostService,
    private smmUserService: SmmUserService,
    private globalService: GlobalService,
    private toastrService: ToastrService) {

  }

  ngDoCheck(): void {

  }

  ngOnInit(): void {
    // console.log('ngOnInit');
    // setTimeout(() => {
    //   this.dashboardFilterComponent.loadReport();
    // }, 300);
  }

  /* ================================================ LỰA CHỌN NGÀY HOẶC CHỦ ĐỀ CỦA DASHBOARD FILTER ================================================ */
  loadDashboardData(filterOptions) {
    this.loadChartDiscusstionSource(filterOptions);// Nguồn thảo luận
    this.loadChartDiscusstionEvolution(filterOptions);// Diễn biến thảo luận
    this.loadChartAuthorPortrait(filterOptions);// Chân dung tác giả
    this.loadChartDiscusstionShade(filterOptions);// Sắc thái thảo luận
    this.loadChartDiscusstionProject(filterOptions);// Chủ đề thảo luận
    this.loadChartDiscussionProvince(filterOptions);//Vị trí thảo luận
    // setTimeout(() => {
    //   // this.isLoadData = false;
    //   // this.filterSemiPieChar = filterOptions;
    // }, 1000);
  }

  /* ================================================ CHART CHỦ ĐỀ THẢO LUẬN - START ================================================ */
  loadChartDiscusstionProject(filterOptions) {
    this.dateInput = { start: filterOptions.start, end: filterOptions.end };
    this.smmPostService.searchPostsDiscussionProject({
      size: 0,
      filter: {
        lte: filterOptions.lte,
        gte: filterOptions.gte,
        projects: filterOptions.projects,
        notSpam: filterOptions.notSpam,
        sourceByTopic: filterOptions.sourceByTopic,
        provinces: filterOptions.provinces,
        index: 'full'
      }
    }).subscribe(response => {
      if (response.success) {
        const data = response.data;
        const aggregations = data.aggregations;

        this.typeNamesSJ = [];
        this.typeCountsSJ = [];

        // Discussion 
        let discuss = aggregations.sentimentDiscuss;
        if (discuss.statistic !== undefined) {
          let buckets = discuss.statistic.seg.buckets; // array

          if (buckets.length > 0) {
            this.dataEmptySJ = false;
            for (var i = 0; i < buckets.length; i++) {
              this.typeNamesSJ.push(buckets[i].key);
              this.typeCountsSJ.push(buckets[i].doc_count);
            }
          } else {
            this.dataEmptySJ = true;
            this.typeNamesSJ = [];
            this.typeCountsSJ = [];
          }
        } else {
          this.dataEmptySJ = true;
          this.typeNamesSJ = [];
          this.typeCountsSJ = [];
        }
      } else {
        this.dataEmptySJ = true;
        this.typeNamesSJ = [];
        this.typeCountsSJ = [];
      }
    }, error => {
      this.dataEmptySJ = true;
      this.typeNamesSJ = [];
      this.typeCountsSJ = [];
    });
  }
  /* ================================================ CHART CHỦ ĐỀ THẢO LUẬN - END ================================================ */

  /* ================================================ CHART NGUỒN THẢO LUẬN - START ================================================ */
  loadChartDiscusstionSource(filterOptions) {
    this.dateInput = { start: filterOptions.start, end: filterOptions.end };
    this.smmPostService.searchPostsDiscussionSource({
      size: 0,
      filter: {
        index: 'full', 
        lte: filterOptions.lte,
        gte: filterOptions.gte,
        projects: filterOptions.projects,
        notSpam: filterOptions.notSpam,
        sourceByTopic: filterOptions.sourceByTopic,
        provinces: filterOptions.provinces
      }
    } ).subscribe(response => {
      if (response.success) {
        const data = response.data;
        this.typeNames = [];
        this.typeCounts = [];

        let countArticle: number = data.aggregations.Article.doc_count;
        let countBlog: number = data.aggregations.Blog.doc_count;
        let countFB: number = data.aggregations.Facebook.doc_count;
        let countForum: number = data.aggregations.Forum.doc_count;
        let countYoutube: number = data.aggregations.Youtube.doc_count;
        let countTiktok: number = data.aggregations.Tiktok.doc_count;

        this.typeNames.push("Bài báo");
        this.typeNames.push("Blog");
        this.typeNames.push("Facebook");
        this.typeNames.push("Diễn đàn");
        this.typeNames.push("Youtube");
        this.typeNames.push("Tiktok");
        if (countArticle > 0) {
          this.typeCounts.push(countArticle);
        } else {
          this.typeCounts.push(0);
        }

        if (countBlog > 0) {
          this.typeCounts.push(countBlog);
        } else {
          this.typeCounts.push(0);
        }

        if (countFB > 0) {
          this.typeCounts.push(countFB);
        } else {
          this.typeCounts.push(0);
        }

        if (countForum > 0) {
          this.typeCounts.push(countForum);
        } else {
          this.typeCounts.push(0);
        }

        if (countYoutube > 0) {
          this.typeCounts.push(countYoutube);
        } else {
          this.typeCounts.push(0);
        }

        if (countTiktok > 0) {
          this.typeCounts.push(countTiktok);
        } else {
          this.typeCounts.push(0);
        }

        if (countArticle == 0 && countBlog == 0 && countFB == 0 && countForum == 0 && countYoutube ==0 && countTiktok ==0) {
          this.dataEmpty = true;
          this.typeNames = [];
          this.typeCounts = [];
        } else {
          this.dataEmpty = false;
        }
      } else {
        this.dataEmpty = true;
        this.typeNames = [];
        this.typeCounts = [];
      }
    }, error => {
      this.dataEmpty = true;
      this.typeNames = [];
      this.typeCounts = [];
    });
  }
  /* ================================================ CHART NGUỒN THẢO LUẬN - END ================================================ */

  /* ================================================ CHART DIỄN BIẾN THẢO LUẬN - START ================================================ */
  loadChartDiscusstionEvolution(filterOptions) {
    this.dateInput = { start: filterOptions.start, end: filterOptions.end };
    this.smmPostService.searchPostsDiscussionEvolution({
      size: 0,
      filter: {
        lte: filterOptions.lte,
        gte: filterOptions.gte,
        notSpam: filterOptions.notSpam,
        projects: filterOptions.projects,
        sourceByTopic: filterOptions.sourceByTopic,
        provinces: filterOptions.provinces,
        index: 'full'
      }
    }).subscribe(response => {
      if (response.success) {
        const data = response.data;

        this.typesMapArray = [];
        this.lineProjectId = [];
        this.dataDE = data.aggregations.byday.buckets;
        for (let index = 0; index < this.dataDE.length; index++) {
          const element = this.dataDE[index];
          const tempMap = new Map();
          tempMap.set(element.key, [element.doc_count]);
          this.typesMapArray.push(tempMap);
        }
        // console.log(this.typesMapArray);
        if (this.typesMapArray.length > 0) {
          this.dataEmptyDE = false;
          this.typeNamesDE = [];
          this.typeNamesDE.push(filterOptions.projects[0].value);
          this.lineProjectId.push(filterOptions.projectSelectedIds);
        } else {
          this.dataEmptyDE = true;
          this.typesMapArray = [];
          this.lineProjectId = [];
        }
      } else {
        this.dataEmptyDE = true;
        this.typesMapArray = [];
      }
    }, error => {
      this.dataEmptyDE = true;
      this.typesMapArray = [];
    });
  }
  /* ================================================ CHART DIỄN BIẾN THẢO LUẬN - END ================================================ */

  /* ================================================ CHART CHÂN DUNG TÁC GIẢ - START ================================================ */
  loadChartAuthorPortrait(filterOptions) {
    // console.log(filterOptions);
    // console.log("loadChartAuthorPortrait");
    this.dateInput = { start: filterOptions.start, end: filterOptions.end };
    this.smmPostService.searchAuthorPortrait({
      filter: {
        lte: filterOptions.lte,
        gte: filterOptions.gte,
        notSpam: filterOptions.notSpam,
        projects: filterOptions.projects,
        sourceByTopic: filterOptions.sourceByTopic,
        provinces: filterOptions.provinces,
        index: 'full'
      }
    }).subscribe(response => {
      if (response.success) {
        const data = response.data;

        this.typeNamesAP = [];
        this.typeCountsAP = [];

        let aggregations = data.aggregations;
        let countMB = aggregations.MienBac.doc_count;
        let countMT = aggregations.MienTrung.doc_count;
        let countMN = aggregations.MienNam.doc_count;
        let countKhac = aggregations.Khac.doc_count;

        this.typeNamesAP.push("Miền Bắc");
        this.typeNamesAP.push("Miền Trung");
        this.typeNamesAP.push("Miền Nam");
        this.typeNamesAP.push("Khác");

        if (countMB > 0) {
          this.typeCountsAP.push(countMB);
        } else {
          this.typeCountsAP.push(0);
        }

        if (countMT > 0) {
          this.typeCountsAP.push(countMT);
        } else {
          this.typeCountsAP.push(0);
        }

        if (countMN > 0) {
          this.typeCountsAP.push(countMN);
        } else {
          this.typeCountsAP.push(0);
        }

        if (countKhac > 0) {
          this.typeCountsAP.push(countKhac);
        } else {
          this.typeCountsAP.push(0);
        }

        if (countMB == 0 && countMT == 0 && countMN == 0 && countKhac == 0) {
          this.dataEmptyAP = true;
          this.typeNamesAP = [];
          this.typeCountsAP = [];
        } else {
          this.dataEmptyAP = false;
        }
      } else {
        this.dataEmptyAP = true;
        this.typeNamesAP = [];
        this.typeCountsAP = [];
      }
    }, error => {
      this.dataEmptyAP = true;
      this.typeNamesAP = [];
      this.typeCountsAP = [];
    });
  }

  /* ================================================ CHART CHÂN DUNG TÁC GIẢ - END ================================================ */

  /* ================================================ CHART SẮC THÁI THẢO LUẬN - START ================================================ */
  loadChartDiscusstionShade(filterOptions) {
    console.log(filterOptions);
    // Hôm nay
    let todayStart = moment().startOf('day').valueOf();
    let todayEnd = moment().endOf('day').valueOf();

    // Hôm qua
    let yesterdayStart = moment().subtract(1, 'day').startOf('day').valueOf();
    let yesterdayEnd = moment().subtract(1, 'day').endOf('day').valueOf();

    // Tuần này
    let thisWeekStart = moment().startOf('isoWeek').valueOf();
    let thisWeekEnd = moment().endOf('isoWeek').valueOf();

    // Tuần trước
    let lastWeekStart = moment().subtract(1, 'week').startOf('isoWeek').valueOf();
    let lastWeekEnd = moment().subtract(1, 'week').endOf('isoWeek').valueOf();

    // Nếu chọn Hôm nay
    let filterDate = { lte: null, gte: null };
    let flagDate = 0;
    if ((filterOptions.gte == todayStart && filterOptions.lte == todayEnd) || (filterOptions.label == "Hôm nay")) {
      filterDate.lte = yesterdayEnd;
      filterDate.gte = yesterdayStart;
      flagDate = 1;
      // console.log("Chọn hôm nay");
      // console.log(filterDate);
    }
    // Nếu chọn Tuần này    
    else if ((filterOptions.gte == thisWeekStart && filterOptions.lte == thisWeekEnd) || (filterOptions.label == "Tuần này")) {
      filterDate.lte = lastWeekEnd;
      filterDate.gte = lastWeekStart;
      flagDate = 2;
      // console.log("Chọn tuần này");      
      // console.log(filterDate);
    }

    //
    this.dateInput = { start: filterOptions.start, end: filterOptions.end };

    // GỌI API
    this.smmPostService.searchDiscussionShade({
      size: 0,
      filter: {
        lte: filterOptions.lte,
        gte: filterOptions.gte,
        projects: filterOptions.projects,
        provinces: filterOptions.provinces,
        notSpam: filterOptions.notSpam,
        sourceByTopic: filterOptions.sourceByTopic,
        index: 'full'
      }
    }).subscribe(response => {
      if (response.success) {
        const data = response.data;
        const aggregations = data.aggregations;

        // POST
        let post = aggregations.Post;
        let totalPost: number = post.doc_count == undefined ? 0 : post.doc_count;
        let likePost: number = post.likeCount.value == undefined ? 0 : post.likeCount.value;
        let sentimentPost = post.sentimentsCount.statistic.seg.buckets; // array
        let sentimentNegPost: number = 0;
        let sentimentPosPost: number = 0;
        let sentimentNeuPost: number = 0;
        let totalSentimentPost: number = 0;
        for (var i = 0; i < sentimentPost.length; i++) {
          if (sentimentPost[i].key == "neg") {
            sentimentNegPost = sentimentPost[i].doc_count;
            totalSentimentPost += sentimentNegPost;
          }
          else if (sentimentPost[i].key == "pos") {
            sentimentPosPost = sentimentPost[i].doc_count;
            totalSentimentPost += sentimentPosPost;
          }
          else if (sentimentPost[i].key == "neu") {
            sentimentNeuPost = sentimentPost[i].doc_count;
            totalSentimentPost += sentimentNeuPost;
          }
        }

        // NEWS (BÀI BÁO)
        let news = aggregations.News;
        let totalNews: number = news.doc_count == undefined ? 0 : news.doc_count;
        let likeNews: number = news.likeCount.value == undefined ? 0 : news.likeCount.value;
        let sentimentNews = news.sentimentsCount.statistic.seg.buckets; // array
        let sentimentNegNews: number = 0;
        let sentimentPosNews: number = 0;
        let sentimentNeuNews: number = 0;
        let totalSentimentNews: number = 0;
        for (var i = 0; i < sentimentNews.length; i++) {
          if (sentimentNews[i].key == "neg") {
            sentimentNegNews = sentimentNews[i].doc_count;
            totalSentimentNews += sentimentNegNews;
          }
          else if (sentimentNews[i].key == "pos") {
            sentimentPosNews = sentimentNews[i].doc_count;
            totalSentimentNews += sentimentPosNews;
          }
          else if (sentimentNews[i].key == "neu") {
            sentimentNeuNews = sentimentNews[i].doc_count;
            totalSentimentNews += sentimentNeuNews;
          }
        }

        // COMMENT
        let comment = aggregations.Comment;
        let totalComment: number = comment.doc_count == undefined ? 0 : comment.doc_count;
        let likeComment: number = comment.likeCount.value == undefined ? 0 : comment.likeCount.value;
        let sentimentComment = comment.sentimentsCount.statistic.seg.buckets; // array
        let sentimentNegComment: number = 0;
        let sentimentPosComment: number = 0;
        let sentimentNeuComment: number = 0;
        let totalSentimentComment: number = 0;
        for (var i = 0; i < sentimentComment.length; i++) {
          if (sentimentComment[i].key == "neg") {
            sentimentNegComment = sentimentComment[i].doc_count;
            totalSentimentComment += sentimentNegComment;
          }
          else if (sentimentComment[i].key == "pos") {
            sentimentPosComment = sentimentComment[i].doc_count;
            totalSentimentComment += sentimentPosComment;
          }
          else if (sentimentComment[i].key == "neu") {
            sentimentNeuComment = sentimentComment[i].doc_count;
            totalSentimentComment += sentimentNeuComment;
          }
        }

        // PUSH DATA CHART
        this.semiTypeNames = [];
        this.semiTypeCounts = [];
        this.semiProjectId = [];
        this.semiPieChartDescription = "";

        let countPos: number = sentimentPosPost + sentimentPosNews + sentimentPosComment;
        let countNeg: number = sentimentNegPost + sentimentNegNews + sentimentNegComment;
        let countNeu: number = sentimentNeuPost + sentimentNeuNews + sentimentNeuComment;
        // let totalSentiment: number = countPos + countNeu + countNeg;

        this.semiTypeNames.push("Tích cực");
        this.semiTypeNames.push("Trung tính");
        this.semiTypeNames.push("Tiêu cực");

        if (countPos > 0) {
          this.semiTypeCounts.push(countPos);
          this.semiProjectId.push(filterOptions.projectSelectedIds);
        } else {
          this.semiTypeCounts.push(0);
          this.semiProjectId.push(filterOptions.projectSelectedIds);
        }

        if (countNeu > 0) {
          this.semiTypeCounts.push(countNeu);
          this.semiProjectId.push(filterOptions.projectSelectedIds);
        } else {
          this.semiTypeCounts.push(0);
          this.semiProjectId.push(filterOptions.projectSelectedIds);
        }

        if (countNeg > 0) {
          this.semiTypeCounts.push(countNeg);
          this.semiProjectId.push(filterOptions.projectSelectedIds);
        } else {
          this.semiTypeCounts.push(0);
          this.semiProjectId.push(filterOptions.projectSelectedIds);
        }

        let totalLike: number = likePost + likeNews + likeComment;
        let totalBuzz: number = totalSentimentPost + totalSentimentNews + totalSentimentComment + totalLike;
        if (totalSentimentPost == 0 && totalSentimentNews == 0 && totalSentimentComment == 0 && totalLike == 0) {
          this.semiPieChartDescription = "";
          this.dataEmptyDS = true;
          this.semiTypeNames = [];
          this.semiTypeCounts = [];
          this.semiProjectId = [];
        } else {
          this.dataEmptyDS = false;
          this.semiPieChartDescription = "Tổng số: " + totalBuzz +
            "<br>MXH: " + totalSentimentPost +
            "<br>Báo chí: " + totalSentimentNews +
            "<br>Bình luận: " + totalSentimentComment +
            "<br>Lượt thích: " + totalLike;
        }

        /* ============================== SO SÁNH CÙNG KỲ - START ==============================*/
        if ((flagDate == 1 || flagDate == 2) && this.dataEmptyDS != true) {
          this.smmPostService.searchDiscussionShade({
            size: 0,
            filter: {
              lte: filterDate.lte,
              gte: filterDate.gte,
              projects: filterOptions.projects,
              provinces: filterOptions.provinces,
              sourceByTopic: filterOptions.sourceByTopic,
              index: 'full'
            }
          }).subscribe(response => {
            if (response.success) {
              // console.log("==================");
              const data = response.data;
              const aggregations = data.aggregations;

              // POST
              let post = aggregations.Post;
              let sentimentPost = post.sentimentsCount.statistic.seg.buckets; // array
              let sentimentNegPost = 0;
              let sentimentPosPost = 0;
              let sentimentNeuPost = 0;
              let totalSentimentPost = 0;
              for (var i = 0; i < sentimentPost.length; i++) {
                if (sentimentPost[i].key == "neg") {
                  sentimentNegPost = sentimentPost[i].doc_count;
                  totalSentimentPost += sentimentNegPost;
                }
                else if (sentimentPost[i].key == "pos") {
                  sentimentPosPost = sentimentPost[i].doc_count;
                  totalSentimentPost += sentimentPosPost;
                }
                else if (sentimentPost[i].key == "neu") {
                  sentimentNeuPost = sentimentPost[i].doc_count;
                  totalSentimentPost += sentimentNeuPost;
                }
              }

              // NEWS
              let news = aggregations.News;
              let sentimentNews = news.sentimentsCount.statistic.seg.buckets; // array
              let sentimentNegNews = 0;
              let sentimentPosNews = 0;
              let sentimentNeuNews = 0;
              let totalSentimentNews = 0;
              for (var i = 0; i < sentimentNews.length; i++) {
                if (sentimentNews[i].key == "neg") {
                  sentimentNegNews = sentimentNews[i].doc_count;
                  totalSentimentNews += sentimentNegNews;
                }
                else if (sentimentNews[i].key == "pos") {
                  sentimentPosNews = sentimentNews[i].doc_count;
                  totalSentimentNews += sentimentPosNews;
                }
                else if (sentimentNews[i].key == "neu") {
                  sentimentNeuNews = sentimentNews[i].doc_count;
                  totalSentimentNews += sentimentNeuNews;
                }
              }

              // COMMENT
              let comment = aggregations.Comment;
              let sentimentComment = comment.sentimentsCount.statistic.seg.buckets; // array
              let sentimentNegComment = 0;
              let sentimentPosComment = 0;
              let sentimentNeuComment = 0;
              let totalSentimentComment = 0;
              for (var i = 0; i < sentimentComment.length; i++) {
                if (sentimentComment[i].key == "neg") {
                  sentimentNegComment = sentimentComment[i].doc_count;
                  totalSentimentComment += sentimentNegComment;
                }
                else if (sentimentComment[i].key == "pos") {
                  sentimentPosComment = sentimentComment[i].doc_count;
                  totalSentimentComment += sentimentPosComment;
                }
                else if (sentimentComment[i].key == "neu") {
                  sentimentNeuComment = sentimentComment[i].doc_count;
                  totalSentimentComment += sentimentNeuComment;
                }
              }

              // SO SÁNH
              let countPos: number = sentimentPosPost + sentimentPosNews + sentimentPosComment;
              let countNeg: number = sentimentNegPost + sentimentNegNews + sentimentNegComment;
              let countNeu: number = sentimentNeuPost + sentimentNeuNews + sentimentNeuComment;
              if (countPos == 0 && countNeu == 0 && countNeg == 0) {
                this.semiPieChartSubTitle = "";
                // this.semiPieChartDescription = "";
                // this.dataEmptyDS = true;
                // this.semiTypeNames = [];
                // this.semiTypeCounts = [];
                // this.semiProjectId = [];
              } else {
                this.dataEmptyDS = false;
                let totalSentiment: number = countPos + countNeu + countNeg;
                let posPercent = this.roundTo(countPos * 100 / totalSentiment, 2);
                let neuPercent = this.roundTo(countNeu * 100 / totalSentiment, 2);
                // let negPercent = this.roundTo(countNeg * 100 / totalSentiment, 2);
                let negPercent = this.roundTo(100 - (parseFloat(posPercent) + parseFloat(neuPercent)), 2);

                this.semiPieChartSubTitle = "";
                if (flagDate == 1) {
                  this.semiPieChartSubTitle += "Hôm qua: ";
                } else if (flagDate == 2) {
                  this.semiPieChartSubTitle += "Tuần trước: ";
                }
                this.semiPieChartSubTitle += "Tích cực: " + posPercent
                  + "%, Trung tính: " + neuPercent
                  + "%, Tiêu cực: " + negPercent + "%";
              }
            }
          }, error => {
            this.dataEmptyDS = true;
            // this.semiTypeNames = [];
            // this.semiTypeCounts = [];
            // this.semiProjectId = [];
          });
        } else {
          this.semiPieChartSubTitle = "";
        }
        /* ============================== SO SÁNH CÙNG KỲ - END ==============================*/
      } else {
        this.dataEmptyDS = true;
        this.semiTypeNames = [];
        this.semiTypeCounts = [];
        this.semiProjectId = [];
      }
    }, error => {
      this.dataEmptyDS = true;
      this.semiTypeNames = [];
      this.semiTypeCounts = [];
      this.semiProjectId = [];
    });
  }
  /* ================================================ CHART SẮC THÁI THẢO LUẬN - END ================================================ */

  /* ================================================ CHART VỊ TRÍ THẢO LUẬN - START ================================================ */
  loadChartDiscussionProvince(filterOptions) {
    this.smmPostService.searchDiscussionProvince({
      size: 0,
      filter: {
        lte: filterOptions.lte,
        gte: filterOptions.gte,
        projects: filterOptions.projects,
        notSpam: filterOptions.notSpam,
        sourceByTopic: filterOptions.sourceByTopic,
        provinces: filterOptions.provinces
      }
    }).subscribe(res => {
      if (res.success && res.data) {
        let provincesAgg = res.data.aggregations.provinces.buckets;
        this.dataProvince = provincesAgg.map(c => ({
          province_name: c.key,
          count: c.doc_count
        }))
      }
    })
  }
  /* ================================================ CHART VỊ TRÍ THẢO LUẬN - END ================================================ */

  /* ================================= COMMON FUNCTION - START =================================  */
  public capitalizeName(name) {
    return name.replace(/\b(\w)/g, s => s.toUpperCase());
  }

  public add(a, b) {
    return a + b;
  }

  public roundTo(n, digits) {
    var negative = false;
    if (digits === undefined) {
      digits = 0;
    }
    if (n < 0) {
      negative = true;
      n = n * -1;
    }
    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    n = (Math.round(n) / multiplicator).toFixed(2);
    if (negative) {
      n = (n * -1).toFixed(2);
    }
    return n;
  }
  /* ================================= COMMON FUNCTION - END =================================  */
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard1/dashboard1.component.ts